import * as Yup from 'yup';

const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;
const loginRegex = /^(?!_)[A-Za-z0-9](?:[A-Za-z0-9_-]{0,61}[A-Za-z0-9])?$/;

const registration = Yup.object().shape({
  login: Yup.string()
    .required('formRegistration.loginError')
    .matches(loginRegex, 'formRegistration.loginErrorFormat')
    .max(63, 'formRegistration.loginMaxLength')
    .min(1, 'formRegistration.loginMinLength'),
  password: Yup.string()
    .required('formRegistration.passwordError')
    .min(10, 'formRegistration.passwordErrorMin')
    .max(20, 'formRegistration.passwordErrorMax')
    .matches(/[a-z]/, 'formRegistration.passwordErrorLower')
    .matches(/[0-9]/, 'formRegistration.passwordErrorNumber'),
  confirmPassword: Yup.string()
    .required('formRegistration.confirmPasswordError')
    .oneOf([Yup.ref('password')], 'formRegistration.confirmPasswordError'),
  email: Yup.string()
    .required('formRegistration.emailEmpty')
    .matches(emailRegex, 'formRegistration.emailCorect')
    .email('formRegistration.emailErrorFormat'),
});

export default registration;
